import http from "./HttpService";

const endpoint = process.env.VUE_APP_BASE_URL;

export function getDocs(accountId) {
  return http.get(`/Documents/${accountId}`, {
    baseURL: endpoint,
  });
}

export function downloadDoc(accountId, docId) {
  return http.get(`/Documents/download/${accountId}/${docId}/encoded`, {
    baseURL: endpoint,
    crossDomain: true,
    headers: {
      responseType: "blob",
    },
  });
}

export function verifyDoc(accountId, documentId, status) {
  return http.put(
    `/Documents?accountId=${accountId}&documentId=${documentId}`,
    {
      approved: status,
    },
    {
      baseURL: endpoint,
    }
  );
}

export function uploadDoc(accountId, file, type) {
  const formData = new FormData();
  formData.append('Type', type);
  formData.append('File', file);

  return http.post(
    `/Documents/upload/${accountId}`,
    formData,
    {
      baseURL: endpoint,
    }
  );
}
